import React from 'react';
import '../../stylesheets/home/sharedSectionStyles.css';

const CommunitySection = () => {
  return (
    // Cambiamos <section> por <div className="content-card">
    <div className="content-card">
      <h2>Asistentes con IA</h2>
      <p className="section-subtitle">
        Utiliza asistentes digitales que generan en minutos entregables clave para tu desarrollo profesional o empresarial.
      </p>
      <ul className="feature-list">
        <li>Mapa de oportunidades.</li>
        <li>Modelo de negocio (9 bloques).</li>
        <li>Hipótesis MVP.</li>
        <li>Pitch profesional.</li>
      </ul>
      <a 
        href="/plans/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="cta-button main-blue"
      >
        Crear con IA
      </a>
    </div>
  );
};

export default CommunitySection;